export default function (version) {
  version.files = version.files.filter((file) => file.type !== 'attachment');

  return version;
}
